/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type NewBookingPopupQueryVariables = {
    vehicleId: string;
    date?: string | null | undefined;
};
export type NewBookingPopupQueryResponse = {
    readonly lastBookingStatus: {
        readonly bookingStatus: string | null;
        readonly lastBooking: string | null;
    } | null;
};
export type NewBookingPopupQuery = {
    readonly response: NewBookingPopupQueryResponse;
    readonly variables: NewBookingPopupQueryVariables;
};



/*
query NewBookingPopupQuery(
  $vehicleId: String!
  $date: String
) {
  lastBookingStatus(vehicleId: $vehicleId, date: $date) {
    bookingStatus
    lastBooking
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vehicleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "vehicleId",
        "variableName": "vehicleId"
      }
    ],
    "concreteType": "LastBookingStatus",
    "kind": "LinkedField",
    "name": "lastBookingStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastBooking",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewBookingPopupQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewBookingPopupQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2533890aea7f4376a4c0ce555a9782cf",
    "id": null,
    "metadata": {},
    "name": "NewBookingPopupQuery",
    "operationKind": "query",
    "text": "query NewBookingPopupQuery(\n  $vehicleId: String!\n  $date: String\n) {\n  lastBookingStatus(vehicleId: $vehicleId, date: $date) {\n    bookingStatus\n    lastBooking\n  }\n}\n"
  }
};
})();
(node as any).hash = '973a1037f859fa7f1109fd115739aff9';
export default node;
